<template>
  <div v-if="loading" class="mx-auto max-w-[1000px] p-4">
    <content-placeholders :rounded="true">
      <content-placeholders-heading :img="true" />
      <content-placeholders-text :lines="3" />
    </content-placeholders>
    <div class="mt-4 px-4">
      <content-placeholders :rounded="true">
        <content-placeholders-text :lines="10" />
      </content-placeholders>
    </div>
  </div>
  <div v-else>
    <template v-if="$route.query.step === 'candidates' && user">
      <SearchResult @goBack="goBack" @goNext="goNext" />
    </template>
    <template v-else-if="$route.query.step === 'candidates' && !user">
      <ClientSignUp />
    </template>
    <template v-else>
      <TalentPlaceSearch @goBack="goBack" @goNext="goNext" />
    </template>
  </div>
</template>

<script>
import { inject } from 'vue';
import SearchResult from '@/views/SearchResult.vue';
import TalentPlaceSearch from '@/views/TalentPlaceSearch.vue';
import ClientSignUp from '@/views/ClientSignUp.vue';
import { mapStores, storeToRefs } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';
import { useUserStore } from '@/stores/user';
import { getState } from '@/services/matchingService';

export default {
  name: 'SearchWrapper',
  components: {
    SearchResult,
    TalentPlaceSearch,
    ClientSignUp,
  },
  setup() {
    const loginDialog = inject('loginDialog');
    return {
      loginDialog,
    };
  },
  data() {
    const { user } = storeToRefs(useUserStore());

    return {
      user,
      loading: true,
      serviceSelectionSteps: ['requirements', 'roles', 'hours', 'candidates'],
    };
  },
  computed: {
    ...mapStores(useCheckoutStore),
  },
  watch: {
    '$route.query.step': {
      immediate: true,
      handler: function () {
        if (this.$route.query.action) {
          return;
        }
        if (this.$route.query.step === 'requirements') {
          return;
        }
        if (this.$route.query.step === 'candidates') {
          return;
        }
        if (
          ![
            getState().query?.keywords?.roles || [],
            getState().query?.keywords?.skills || [],
            getState().query?.keywords?.tools || [],
            getState().query?.keywords?.default || [],
          ].flat()?.length &&
          !(getState().query?.rids && getState().query?.rids.length !== 0)
        ) {
          return this.$router
            .push({
              query: { ...this.$route.query, step: 'requirements' },
            })
            .catch(() => {});
        }
        if (this.$route.query.step === 'roles') {
          return;
        }
        if (!getState().query?.rids?.length) {
          return this.$router
            .push({
              query: { ...this.$route.query, step: 'roles' },
            })
            .catch(() => {});
        }
        if (this.$route.query.step === 'hours') {
          return;
        }
        if (
          !getState().query?.hours?.length ||
          (getState().query?.rids &&
            getState().query?.hours &&
            getState().query?.hours?.length !== getState().query?.rids?.length)
        ) {
          return this.$router
            .push({
              query: { ...this.$route.query, step: 'hours' },
            })
            .catch(() => {});
        }
        if (!this.$route.query.step) {
          this.$router
            .push({
              query: { ...this.$route.query, step: 'candidates' },
            })
            .catch(() => {});
        }
      },
    },
  },
  created() {
    if (!this.user && this.$route.params.uuid) {
      this.loginDialog.open({
        onClose: this.onClose,
      });
      return;
    }

    this.loading = false;
  },
  methods: {
    onClose(auth) {
      if (auth) {
        this.$router
          .replace(
            `/search/${getState()?.query?.uuid || this.$route.params.uuid}`
          )
          .catch(() => {});
      } else {
        this.$router.replace(`/search`);
        this.checkoutStore.removeMatchingCriteria();
      }

      this.loading = false;
    },
    goBack() {
      return this.$router
        .push({
          query: {
            ...this.$route.query,
            step: this.serviceSelectionSteps[
              this.serviceSelectionSteps.findIndex(
                (el) => el === this.$route.query.step
              ) - 1
            ],
          },
        })
        .catch(() => {});
    },
    goNext() {
      return this.$router
        .push({
          query: {
            ...this.$route.query,
            step: this.serviceSelectionSteps[
              this.serviceSelectionSteps.findIndex(
                (el) => el === this.$route.query.step
              ) + 1
            ],
          },
        })
        .catch(() => {});
    },
  },
};
</script>
